import {
  MATCH_TYPE_PAYMENT_DD_RETURN,
  MATCH_TYPE_PAYMENT_FUNDS_TRANSFER,
  MATCH_TYPE_PAYMENT_REPAYMENT,
  MATCH_TYPE_PAYMENT_PASS_THROUGH,
} from '../match/constants'

export const REDUCER_KEY = 'payments'
export const ACTION_KEY = 'payments/FETCH'

export const datePathMap = {
  [MATCH_TYPE_PAYMENT_FUNDS_TRANSFER]: ['renderedFundsTransferDueDate'],
  [MATCH_TYPE_PAYMENT_REPAYMENT]: ['repayment', 'repaymentDate'],
  [MATCH_TYPE_PAYMENT_DD_RETURN]: ['repayment', 'repaymentDate'],
  [MATCH_TYPE_PAYMENT_PASS_THROUGH]: ['order', 'createdOn'],
}

export const datePathFilterMap = {
  [MATCH_TYPE_PAYMENT_FUNDS_TRANSFER]: ['fundsTransfers', 'fundsTransferDueDate'],
  [MATCH_TYPE_PAYMENT_REPAYMENT]: ['repayment', 'repaymentDate'],
  [MATCH_TYPE_PAYMENT_DD_RETURN]: ['repayment', 'repaymentDate'],
  [MATCH_TYPE_PAYMENT_PASS_THROUGH]: ['order', 'createdOn'],
}

export const intendedPurposePathMap = {
  [MATCH_TYPE_PAYMENT_FUNDS_TRANSFER]: ['sellerIntendedPurpose'],
  [MATCH_TYPE_PAYMENT_REPAYMENT]: ['repayment', 'buyerIntendedPurpose'],
  [MATCH_TYPE_PAYMENT_DD_RETURN]: ['repayment', 'buyerIntendedPurpose'],
}

export const openAmountPathMap = {
  [MATCH_TYPE_PAYMENT_FUNDS_TRANSFER]: ['fundsTransfers', 0, 'openAmount'],
  [MATCH_TYPE_PAYMENT_REPAYMENT]: ['repayment', 'openAmount'],
  [MATCH_TYPE_PAYMENT_DD_RETURN]: ['repayment', 'openAmount'],
  [MATCH_TYPE_PAYMENT_PASS_THROUGH]: ['amount'],
}

export const quickFilterOptions = [
  {
    label: 'All Entries',
    value: 'ALL_ENTRIES',
  },
  {
    label: 'Based on Bank Account',
    value: 'BASED_ON_BANK_ACCOUNT',
  },
  {
    label: 'Similar Open Amount',
    value: 'OPEN_AMOUNT',
  },
]
